module.exports = __webpack_public_path__ + "fullstack.1MCn3yqQ.svg";